import * as types from "../types";

export const getTags = ({ resource }) => ({
  type: types.GET_TAGS,
  request: {
    url: `/${resource}/tags`,
    method: "GET",
    params: {
      "q[s]": "name asc"
    }
  }
});
